<template>
  <div>
    <download-file :isShowDownloadIcon="true" :title="this.$t('wholeSalePriceTable.guide') + '.pdf'" uatId="16684c13d704b6f7cf031a14fed85db4" proId="16686126b910ae8203bd25b4d89a4756"></download-file>
    <m-assembly-table ref="pageForm"
                      :total="total"
                      :loading="loading"
                      :formData="formData"
                      :columns="columns"
                      :data="data"
                      :settings="settings"
                      :currentPage="page"
                      :pageSize="pageSize"
                      :tableButtons="tableButtons"
                      @onSubmit="onSubmit"
                      @onPageSizeChange="onPageSizeChange"
                      @onCurrentPageChange="onCurrentPageChange"
    >
    </m-assembly-table>
  </div>
</template>

<script>
  import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
  import axios from 'axios';
  import {formatDateTime} from '@/utils/datetime-format.js';
//  import mTable from 'components/awesome/page/table/index';
  export default {
    name: 'wholeSalePriceQuery',
    components: {mAssemblyTable},
    data() {
      return {
        vendorCode: '',
        currLang: this.$i18n.locale,
        page: 1,
        pageSize: 20,
        // result: {},
        loading: false,
        formData: {
          row: 3,
          items: [
            {
              value: '',
              field: 'orgCode',
              disabled: false,
              layout: {
                span: 8,
                offset: 0,
                row: 1
              },
              methods: {
                change() {
                }
              },
              options: {
                multiple: false,
                values: []
              },
              type: 'select',
              title: this.$t('wholeSalePriceTable.bussObj')
            },
            {
              isDouble: true,
              value: '',
              field: 'startDate',
              type: 'datePicker',
              title: this.$t('wholeSalePriceQry.startEndDate'),
              style: 'width: 100%;',
              layout: {
                row: 1,
                span: 8,
                offset: 0
              },
              options: {
                type: 'date',
                format: 'yyyy-MM-dd'
              },
              validators: {
                required: {
                  required: true,
                  message: this.$t('wholeSalePriceQry.dateRequired')
                }
              }
            },
            {
              hide: true,
              value: '',
              field: 'endDate',
              type: 'datePicker',
              title: '-',
              style: 'width: 100%;',
              layout: {
                row: 1,
                span: 4,
                offset: 0
              },
              options: {
                type: 'date',
                format: 'yyyy-MM-dd'
              },
              validators: {
                required: {
                  required: true,
                  message: this.$t('wholeSalePriceQry.dateRequired')
                }
              }
            },
            {
              isDouble: true,
              value: '',
              field: 'itemCodeStart',
              disabled: false,
              layout: {
                span: 8,
                offset: 0,
                row: 1
              },
              methods: {},
              options: {
                type: 'text',
                rows: 1
              },
              type: 'text',
              title: this.$t('wholeSalePriceTable.materialCode')
            },
            {
              hide: true,
              value: '',
              field: 'itemCodeEnd',
              disabled: false,
              layout: {
                span: 4,
                offset: 0,
                row: 1
              },
              methods: {},
              options: {
                type: 'text',
                rows: 1
              },
              type: 'text',
              title: '-'
            }
          ],
          buttons: {
            showSubmit: true,
            showReset: true,
            layout: {
              span: 24,
              push: 8
            }
          }
        },
        columns: {
          showCheckbox: false,
          showButtons: false,
          columns: [
            {
              title: this.$t('wholeSalePriceTable.bussObj'),
              key: 'orgName',
              sortable: false,
              tooltip: true,
              minWidth: 170,
              render: (h, params) => {
                return h('Tooltip', {
                  props: {
                    content: params.row.orgName,
                    placement: 'top'
                  },
                  class: 'm-tooltip-overflow'
                }, params.row.orgName);
              }
            },
            {
              title: this.$t('wholeSalePriceTable.purchaseType'),
              key: 'categoryNameConcat',
              sortable: false,
              align: 'left',
              minWidth: 140,
              render: (h, params) => {
                return h('Tooltip', {
                  props: {
                    content: params.row.categoryNameConcat,
                    placement: 'top'
                  },
                  class: 'm-tooltip-overflow'
                }, params.row.categoryNameConcat);
              }
            },
            {
              title: this.$t('wholeSalePriceTable.materialCode'),
              key: 'itemCode',
              sortable: false,
              minWidth: 120
            },
            {
              title: this.$t('wholeSalePriceTable.materialDesc'),
              key: 'itemDesc',
              sortable: false,
              align: 'center',
              minWidth: 190,
                render: (h, params) => {
                    return h('Tooltip', {
                        props: {
                            content: params.row.itemDesc,
                            placement: 'top'
                        },
                        class: 'm-tooltip-overflow'
                    }, params.row.itemDesc);
                }
            },
            {
              title: this.$t('wholeSalePriceTable.units'),
              key: 'unitMeasCode',
              sortable: false,
              align: 'center',
              minWidth: 70
            },
            {
              title: this.$t('wholeSalePriceTable.currency'),
              key: 'currencyCode',
              sortable: false,
              align: 'center',
              minWidth: 70
            },
            { // 不含税价
              title: this.$t('wholeSalePriceTable.haveNotTaxPrice'),
              key: 'priceOverride',
              sortable: false,
              align: 'right',
              minWidth: 120
            },
            {
              title: this.$t('wholeSalePriceTable.startDate'),
              key: 'startDate',
              sortable: true,
              align: 'center',
              minWidth: 90
            },
            {
              title: this.$t('wholeSalePriceTable.endDate'),
              key: 'endDate',
              sortable: true,
              align: 'center',
              minWidth: 90
            }
          ]
        },
        tableButtons: {
          customButtons: [
            {
              name: 'btn-export',
              icon: 'archive',
              label: this.$t('common.export'),
              loading: false,
              click: () => {
                if (this.$refs.pageForm.$children[0].$children[0].validateForm()) {
                  this.exportExcel();
                }
              }
            }
          ]
        },
        total: 0,
        data: [],
        condition: {},
        settings: {
          needPager: true,
          showElevator: true,
          showSizer: true,
          pageSizeOpts: [20, 50, 80, 100],
          needSearch: true,
          needValidation: true,
          pageSize: 100
        }
      };
    },
    mounted() {
      this.vendorCode = JSON.parse(localStorage.getItem('supplierInfo')).vendorCode;
      this.getBussObj();
    },
    watch: {
    //   result: function () {
    //     if (this.result.success === true) {
    //       this.data = this.result.data.records;
    //       this.total = this.result.data.total;
    //     } else {
    //       this.$Modal.error({
    //         title: this.$t('common.warn'),
    //         content: this.result.msg
    //       });
    //     }
    //     this.loading = false;
    //   }
    },
    methods: {
      getBussObj() {
        this.loading = true;
        axios.get('/gscint/vendor/getOULovNew2?labelName=ouName&valueName=ouCode&vendorSiteActive=Y', {
          params: {}
        }).then(res => {
          this.formData.items[0].options.values = res.data.data || [];
          this.loading = false;
        });
      },
      onSearch() {
        var orgCodeVal = this.condition.orgCode;
        if (orgCodeVal === undefined) {
          orgCodeVal = '';
        }

        var itemCodeStartVal = this.condition.itemCodeStart;
        if (itemCodeStartVal === undefined) {
          itemCodeStartVal = '';
        }

        var itemCodeEndVal = this.condition.itemCodeEnd;
        if (itemCodeEndVal === undefined) {
          itemCodeEndVal = '';
        }

        var startDate = this.condition.startDate;
        if (this.isEmptyValue(startDate)) {
          this.$Modal.error({
            title: this.$t('common.warn'),
            content: this.$t('wholeSalePriceTable.errorNullStartDate')}); // 请选择起始日期
          return;
        }
        var endDate = this.condition.endDate;
        if (this.isEmptyValue(endDate)) {
          this.$Modal.error({
            title: this.$t('common.warn'),
            content: this.$t('wholeSalePriceTable.errorNullEndDate')}); // 请选择结束日期
          return;
        }

        let params = {
            lan: this.currLang,
            orgCode: orgCodeVal,                // 业务实体
            itemCodeStart: itemCodeStartVal,    // 物料编码开始
            itemCodeEnd: itemCodeEndVal,        // 物料编码结束
            startDate: startDate,               // 开始日期
            endDate: endDate,                   // 截止日期
            vendorCode: this.vendorCode,         // 供应商编码
            pageNum: this.page,
            pageSize: this.pageSize
        };
        this.loading = true;
        axios.get('/srmprice/gsc/packagePriceInfo/packagePriceQuery', {
                params
            }).then(res => {
                this.loading = false;
                if (res.data.data.status === 0) {
                    this.data = res.data.data.data.list;
                    this.total = res.data.data.data.total;
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: res.data.data.msg
                    });
                }
        }).catch(err => {
            this.loading = false;
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('common.error1'),
                error: err.stack.toString()
            });
        });
      },
      /** 查询**/
      onSubmit: function(page, pageSize, condition) {
        this.page = page;
        this.pageSize = pageSize;
        this.condition = condition;
        this.onSearch();
      },
      // 页容量改变时触发
      onPageSizeChange(page, pageSize, condition) {
        this.page = page;
        this.pageSize = pageSize;
        this.condition = condition;
        this.onSearch();
      },
      // 当前页改变时触发
      onCurrentPageChange(page, pageSize, condition) {
        this.page = page;
        this.pageSize = pageSize;
        this.condition = condition;
        this.onSearch();
      },
      isEmptyValue(value) {
        if (value === null || value === 'null' || value === undefined || value === 'undefined' || value === '') {
          return true;
        }
        return false;
      },
      exportExcel() {
        let params = {};
        this.formData.items.forEach(item => {
          if (item.type === 'datePicker') {
            params[item.field] = item.value ? formatDateTime(new Date(item.value), item.options.format) : '';
          } else if (item.field) {
            params[item.field] = item.value;
          }
        });
        // let paramsStr = '';
        // for (let key in params) {
        //     if (params.hasOwnProperty(key)) {
        //       paramsStr += key + '=' + params[key] + '&';
        //     }
        // }
        // paramsStr = paramsStr.slice(0, -1);
        // console.log('paramsStr:', paramsStr);
        params.lan = this.currLang;
        params.vendorCode = this.vendorCode;
        this.tableButtons.customButtons[0].loading = true;
        var a = document.createElement('a');
        a.href = '/srmprice/gsc/packagePriceInfo/packagePriceExport?paraJson=' + encodeURI(JSON.stringify(params));
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => {
          this.tableButtons.customButtons[0].loading = false;
        }, 5000);
      }
    }
  };
</script>

<style scoped>

</style>
